import {lighten} from 'polished';
import styled, {css} from 'styled-components';

import {breakpoint, colors, border, buttonReset} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const HeaderControlsTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
`;
export const ControlsTopWrapper = styled(HeaderControlsTop)`
    width: auto;
`;

export const QuickFiltersRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    min-height: 36px;
`;

export const QuickFilterControls = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

export const QuickFilterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
`;

export const QuickFiltersLabel = styled.span`
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    color: ${colors.darkGrey};
`;

export const QuickFilterButton = styled.button<{isActive?: boolean}>`
    ${buttonReset};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    padding: 6px 12px;
    border-radius: ${border.radius};
    border: 1px solid ${colors.brandPrimary};
    background: ${colors.white};
    color: ${colors.brandPrimary};
    text-decoration: none;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease-in-out;

    ${(p) =>
        p.isActive &&
        css`
            background: ${colors.brandPrimary};
            color: ${colors.white};
        `}
`;

export const QuickFilterClear = styled.button`
    ${buttonReset};
    color: ${colors.textSecondary};
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;

    &:hover {
        color: ${colors.brandPrimary};
    }
`;

export const NavigationWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const ControlsWrapper = styled.div`
    width: 100%;
    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;

export const GtinEditLink = styled.div`
    color: ${colors.brandPrimary};
    cursor: pointer;
`;

export const FavoriteButton = styled.button<{isActive?: boolean}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;

    &:disabled {
        cursor: default;
    }

    svg {
        width: 18px;
        height: 18px;

        & path {
            stroke: #ababab;
            ${(p) =>
                p.isActive &&
                css`
                    fill: #ffb900;
                    stroke: #ffb900;
                `}
        }
    }
`;

export const FavoriteCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StatusWrapper = styled.div<{color: string}>`
    box-sizing: border-box;
    padding: 8px 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    border-radius: 4px;
    color: ${(p) => p.color};
    background-color: ${(p) => lighten(0.38, p.color)};
`;

export const StatusWrapperText = styled(StatusWrapper)<{color: string}>`
    background-color: transparent;
`;
